export default __webpack_public_path__ + "static/media/bone-devil.ff954d31.jpeg";